/*
 * Get-staff.ts
 * Description: Includes the declaration
 * of the function for creating staff members
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL, EmailTaken} from '@/ts/variables';
// Importing user interface
import {User} from '@/ts/auth/validate-register';

/**
 * Creating a staff member
 *
 * @return {Object} Promise - a list of staff members
 * @param {String} slug - id of the restaurant
 * @param {String[]} errors - a list of errors
 * @param {User} data - user data
 */
export function postStaff(errors: string[], data: User, slug: string) {
    const jwt = localStorage.getItem('jwt');
    return new Promise((resolve, reject) => {
        Axios({
            url:  APIURL + 'restaurants/' + slug + '/users',
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data,
        }).then(() => {
            resolve();
        }).catch((error) => {
            const err = error.response.data;
            // Checking if the field email exists in errors, to prevent errors.
            if (Array.isArray(err.errors.email)) {
                for (const temp of err.errors.email) {
                    if (temp === 'The email has already been taken.') {
                        errors.push(EmailTaken);
                    } else {
                        errors.push(temp);
                    }
                }
            }
            // Checking if the field password exists in errors, to prevent errors.
            if (Array.isArray(err.errors.password)) {
                for (const temp of err.errors.password) {
                    errors.push(temp);
                }
            }
            reject();
        });
    });
}
